import React from 'react';
import { useLocation } from "react-router-dom";
import { NavbarBrand, Nav } from 'reactstrap';
import { BsFacebook, BsInstagram, BsEnvelope, BsWhatsapp } from 'react-icons/bs';

import MainSearchForm from '../MainSearch/MainSearchForm';
import { LoginNavItem, LoginNavItemMobile } from './CustomLoginNavItem/LoginNavItem';
import Menu from './Menu';

import './Header.scss';
import './HeaderSearch.scss';

import logoClickHogar from '../../assets/img/logo-clickHogar.png';
import Slogan from '../Slogan/Slogan';

const SearchTopHeader = () => (
  <>
    <div className="container-fluid headerSearch__brand d-flex flex-column flex-md-row justify-content-between">
      
      <div className="d-flex align-items-center">
        <NavbarBrand href="/">
          <img className="img-fluid" src={logoClickHogar} alt="Click Hogar" />
        </NavbarBrand>
        <div className="header__slogan d-none d-md-block">
          <Slogan />
        </div>
      </div>


      <div className="d-flex align-items-center">
        
        <MainSearchForm />
      
        <section className="header__top d-none d-md-flex justify-content-end align-items-center">
          <a title="Seguinos..." className="d-none d-md-block header__link" target="_blank" href="https://www.facebook.com/clickhogarbahiablanca"><BsFacebook /></a>
          <a title="Seguinos..." className="d-none d-md-block header__link" target="_blank" href="https://www.instagram.com/clickhogarbahiablanca/"><BsInstagram /></a>
          <a title="Consúltanos..." className="d-none d-md-block header__link" target="_blank" href="https://api.whatsapp.com/send?phone=5492915327990&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20"><BsWhatsapp /></a>
          <a title="Consúltanos..." className="d-none d-md-block header__link mr-3" target="_blank" href="mailto:clickhogarbahiablanca@gmail.com"><BsEnvelope /></a>

          <div className="header__loguin">
            <Nav>
              <LoginNavItem closeHeader={false} />
            </Nav>
          </div>
        </section>
      </div>
    </div>
  </>
)

const TopHeader = () => (
  <React.Fragment>
    <section className="header__top d-none d-md-flex justify-content-end">
      <div className="header__loguin">
        <Nav>
          <LoginNavItem closeHeader={false} />
        </Nav>
      </div>
    </section>
    <NavbarBrand href="https://www.clickhogarbahia.com.ar/">
      <img className="img-fluid" src={logoClickHogar} alt="Click Hogar" />
    </NavbarBrand>
  </React.Fragment>
)

const Header = (props) => {

  const { pathname } = useLocation();
  const isRoot = pathname === "/";

  return (
    <header className="headerSearch">
      <SearchTopHeader />
      <Menu />
    </header>
  );
};

export default Header;
